/** Tiny hash router: #/<sectorId>. Keeps the URL and store in sync. */
export const router = {
  current(): string {
    return window.location.hash.replace(/^#\/?/, '').trim();
  },
  navigate(sectorId: string): void {
    if (this.current() !== sectorId) window.location.hash = `/${sectorId}`;
  },
  onChange(fn: (sectorId: string) => void): void {
    window.addEventListener('hashchange', () => fn(this.current()));
  },
};
